module.exports = __webpack_public_path__ + "static/home-2-d-50e342448fea72a9947d5f2e5aef9e22.mp4";